import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';
  
export function rules_dctw(newState, state) {
  var newrule = includeRule(newState, state, 'dctw')
  
    newrule = excludeRule(newState, state, [
        ['type', ['R','P']],
        ['ds', ['HRD','HOV','HCU','HECU']],
        ['dctw', ['3']]], newrule)

    newrule = excludeRule(newState, state, [
        //['type', ['R','P']],
        ['sh', ['R1','R2','R3','R4','R5','R6','R7','R8','R9','R10','R11','R12','R13','R14','R15','P1','P2','P3','P4','P5','P6','P7','P9','P10']],
        ['ds', ['HPS']],
        ['dctw', ['2']]], newrule)

    newrule = excludeRule(newState, state, [
        //['type', ['R','P']],
        ['sh', ['P8']],
        ['ds', ['HPS']],
        ['dctw', ['3']]], newrule)

    newrule = excludeRule(newState, state, [
        ['type', ['E','B']],
        ['dctw', ['3']]], newrule)

    return newrule
}



// WEBPACK FOOTER //
// ./src/reducers/rules_dctw.js